import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from "src/environments/environment";
import { Constant } from "src/app/shared/Constants/constant";

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  ClientType!:string;
  ConstantClient!:string;
  constructor(private title:Title) {
    this.ClientType = environment.ClientName;
    this.ConstantClient = Constant.Virtusa;
    this.title.setTitle('Verisource')
  }

  setTitle(title:String){
    var newTitle = environment.ClientName + ` | ${title}`;
    this.title.setTitle(newTitle);
  }
}
